const runTimer = {
  data() {
    return {
      initValue: '00:00:00',
      hour: 0,
      minute: 0,
      second: 0,
      hourStr: '',
      minuteStr: '',
      secondStr: '',
      intTimer: null,
    };
  },
  created() {
    this.$bus.$on('called', () => {
      this.reset();
      this.start();
    });
  },
  activated() {
    console.log({
      activated: this.initValue,
    });
  },
  methods: {
    start() {
      this.intTimer = setInterval(this.timer, 1000);
    },
    timer() {
      this.second = this.second + 1;
      if (this.second >= 60) {
        this.second = 0;
        this.minute = this.minute + 1;
      }
      if (this.minute >= 60) {
        this.minute = 0;
        this.hour = this.hour + 1;
      }
      this.secondStr = this.second < 10 ? '0' + this.second : this.second + '';
      this.minuteStr = this.minute < 10 ? '0' + this.minute : this.minute + '';
      this.hourStr = this.hour < 10 ? '0' + this.hour : this.hour + '';
      this.initValue =
        this.hourStr + ':' + this.minuteStr + ':' + this.secondStr;
    },
    stop() {
      window.clearInterval(this.intTimer);
    },
    reset() {
      this.stop();
      this.initValue = '00:00:00';
    },
  },
  beforeDestroy() {
    this.hour = 0;
    this.minute = 0;
    this.second = 0;
    this.hourStr = '';
    this.minuteStr = '';
    this.secondStr = '';
    this.intTimer = null;
    this.initValue = '00:00:00';
    this.stop();
  },
};
export default runTimer;
